import React, {useState} from "react";
import {useNavigate} from "react-router-dom";
import axiosInstance from "../utils/axiosInstance";
import ErrorAlert from "./ErrorAlert";

const CancelFileButton = ({fileId, status, isAdmin, price_status, price}) => {
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState();
    const [showModal, setShowModal] = useState(false);
    const navigate = useNavigate();

    const handleCancel = async () => {
        try {
            setLoading(true);
            await axiosInstance.put(`/files/${fileId}/cancel`);
            setLoading(false);
            if (!isAdmin) {
                navigate("/my-files");
            } else {
                navigate("/admin/all-files");
            }
        } catch (error) {
            setLoading(false);
            if (error.response.status === 400) {
                setErrorMessage(error.response.data.message);
                return;
            }
            setErrorMessage("Something went wrong");
        } finally {
            setShowModal(false);
        }
    };

    return (
        <div className="mt-6">
            {errorMessage && (
                <div>
                    {" "}
                    <ErrorAlert errorMessage={errorMessage}/> <br/>{" "}
                </div>
            )}
            {isAdmin ||
            (price_status &&
                price_status === "UNPAID" &&
                status !== "CANCELED" &&
                status !== "REFUNDED") ? (
                <button
                    onClick={() => setShowModal(true)}
                    disabled={loading}
                    className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-lg flex items-center gap-2"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-5 w-5"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                    >
                        <path
                            fillRule="evenodd"
                            d="M3 4a2 2 0 012-2h10a2 2 0 012 2v12a2 2 0 01-2 2H5a2 2 0 01-2-2V4zm5 4a1 1 0 000 2h4a1 1 0 000-2H8z"
                            clipRule="evenodd"
                        />
                    </svg>
                    Click here to cancel
                </button>
            ) : (
                !isAdmin &&
                (status === "CANCELED" ? (
                    <p className="text-red-800 bg-red-100 border-l-4 border-red-500 p-4 mt-2 dark:text-red-200 dark:bg-red-700 dark:border-red-400">
                        Your file is already canceled
                    </p>
                ) : status === "REFUNDED" ? (
                    <p className="text-yellow-800 bg-yellow-100 border-l-4 border-yellow-500 p-4 mt-2 dark:text-yellow-200 dark:bg-yellow-700 dark:border-yellow-400">
                        Your file is already refunded, <b>CRS:{price}</b>
                    </p>
                ) : null)
            )}
            {showModal && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
                    <div className="bg-white p-6 rounded-lg">
                        <h3 className="text-lg text-black font-semibold">
                            Are you sure you want to cancel?
                        </h3>
                        <div className="mt-4 flex gap-4">
                            <button
                                onClick={handleCancel}
                                className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-lg"
                            >
                                {loading ? "Cancelling..." : "Yes"}
                            </button>
                            <button
                                onClick={() => setShowModal(false)}
                                className="bg-gray-300 hover:bg-gray-400 text-black px-4 py-2 rounded-lg"
                            >
                                No
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default CancelFileButton;
